import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SellerService {

  constructor(private http: HttpClient) { }

  public getStoreAttributes(storeLocation: string): Observable<any> {
    const url = `${environment.apiOrigin}/SellerService/api/sellers/default/stores/attributes/${storeLocation}`;
    return this.http.get(url);
  }

  getAllStores(): Observable<any> {
    const url = `${environment.apiOrigin}/SellerService/api/sellers/default/stores/attributes`;
    return this.http.get(url);
  }
}
